module.exports = __webpack_public_path__ + "static/bandcamp-6f55fe3d4d4d6c5cdbc0defe457b38e2.png";